export const BRAND_URL = '/assets/images/grameenphone_logo1.jpeg';

export const AGENT_AVATAR = 'https://cdn.mevrik.com/images/avatar-gp-bot.jpg';

export const CUSTOMER_AVATAR = '/assets/images/avatar-24.png';
